export const URBANIK_LOCALE = 'es-EC';
export const URBANIK_TIME_ZONE = 'America/Guayaquil';

const usdFormatter = new Intl.NumberFormat(URBANIK_LOCALE, {
  style: 'currency',
  currency: 'USD',
  currencyDisplay: 'symbol',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
const dateFormatter = new Intl.DateTimeFormat(URBANIK_LOCALE, {
  dateStyle: 'long',
  timeZone: URBANIK_TIME_ZONE,
});
const dateTimeFormatter = new Intl.DateTimeFormat(URBANIK_LOCALE, {
  dateStyle: 'medium',
  timeStyle: 'short',
  hourCycle: 'h23',
  timeZone: URBANIK_TIME_ZONE,
});

export function formatUsd(value: string | number): string {
  const numericValue = typeof value === 'string' ? Number(value) : value;
  if (!Number.isFinite(numericValue)) throw new TypeError('El valor monetario debe ser finito.');
  return usdFormatter.format(numericValue);
}
export function formatDate(value: string | Date): string {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) throw new TypeError('La fecha debe ser válida.');
  return dateFormatter.format(date);
}
export function formatDateTime(value: string | Date): string {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) throw new TypeError('La fecha y hora deben ser válidas.');
  return dateTimeFormatter.format(date);
}
